/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@efexteam/components';
import ExpandMore from '@efex-components/common/ExpandMore';
import Autorenew from '@mui/icons-material/Autorenew';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Alert,
  Card,
  CardActions,
  CardContent,
  Collapse,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { StakeHoldersFormData } from '../../../../../../services/client/types';
import FormRefactor from './form';

interface IStakeHolders {
  index: number;
  formError: string;
  remove: (index: number) => void;
  handleDropChangeFile: (files: FileList, name: string) => void;
  data?: StakeHoldersFormData;
  loading: boolean;
  stakeholderId?: number;
  getStakeHolder: () => void;
}

const StakeHolderFormUSA = ({
  index,
  formError,
  remove,
  handleDropChangeFile,
  getStakeHolder,
  data,
  loading = false,
  stakeholderId,
}: IStakeHolders) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState<boolean>(!stakeholderId);
  const [confirmDeletion, setConfirmDeletion] = useState(false);

  const { id } = data || {};

  const getName = (): string | undefined => {
    const { name, lastName, secondLastName } = data || {};
    if (!name || !lastName) return undefined;
    return `${name} ${lastName} ${secondLastName}`;
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleRemove = () => {
    if (id) {
      setConfirmDeletion(true);
      return;
    }
    remove(index);
  };

  const { neighborhood, secondLastName, kycStatus, ...formPrevData } =
    data as StakeHoldersFormData;
  return (
    <>
      <Card>
        <CardActions disableSpacing>
          <Typography variant="h6" className="capitalize">
            {getName() ?? t('onbStHlSectionTitle', { index: index + 1 })}
          </Typography>
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon />
          </ExpandMore>
        </CardActions>
        <Collapse in={expanded} timeout="auto">
          <CardContent>
            {formError.length > 0 ? (
              <Alert variant="outlined" severity="error">
                {formError}
              </Alert>
            ) : null}

            <FormRefactor
              getStakeHolder={getStakeHolder}
              handleDropChangeFile={handleDropChangeFile}
              handleRemove={handleRemove}
              kycStatus={kycStatus}
              defaultValues={
                Object.keys(formPrevData).length ? formPrevData : null
              }
            />
          </CardContent>
        </Collapse>
      </Card>

      {confirmDeletion ? (
        <Dialog
          open={confirmDeletion}
          onClose={() => setConfirmDeletion(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle
            showCloseButton
            onClick={() => setConfirmDeletion(false)}
          >
            <Typography variant="h6" className="!max-w-[80%] !mx-auto">
              {t('onbConfirmRemove')}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Button
              appearance="secondary"
              className="block mx-auto mt-5"
              endIcon={
                !loading ? (
                  <DeleteIcon />
                ) : (
                  <Autorenew className="animate-spin" />
                )
              }
              onClick={() => {
                remove(id ?? index);
                setConfirmDeletion(false);
              }}
            >
              {t('onbRemove')}
            </Button>
          </DialogContent>
        </Dialog>
      ) : null}
    </>
  );
};

export default StakeHolderFormUSA;
